<template>
  <div class="wrapper">
    <div class="btn" @click="push">前往茂名慢病中心要闻服务号</div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  methods: {
    push(){
      window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUyOTA2OTY0Ng==&scene=124#wechat_redirect"
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn{
    font-size: 18px;
    text-align: center;
    background: rgb(83, 192, 255);
    padding: 20px;
    // letter-spacing: 1px;
    // margin: 10px;
    border-radius: 4px;
    border: 1px solid #3eb8ff;
    color: #FFF;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/user/gotogzh.vue